/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';
import {
  ClinicalTrialsListState,
  ClinicalTrialsListFetchAction,
  ClinicalTrialsListFetchSuccessAction,
} from './clinicalTrialsList.types';
import { ErrorAction, createSliceHook } from '../helpers';

const initialState: ClinicalTrialsListState = {
  data: {},
  loading: false,
  error: undefined,
};

export const clinicalTrialsListSlice = createSlice({
  name: 'clinicalTrialsList',
  initialState,
  reducers: {
    fetchClinicalTrialsList: (state, action: ClinicalTrialsListFetchAction) => {
      state.loading = true;
    },
    fetchClinicalTrialsListSuccess: (
      state,
      action: ClinicalTrialsListFetchSuccessAction
    ) => {
      state.data = action.payload;
      state.loading = false;
    },
    fetchClinicalTrialsListFailure: (state, action: ErrorAction) => {
      state.error = action.payload;
      state.loading = false;
    },
    ddd() {},
  },
});

export const {
  fetchClinicalTrialsList,
  fetchClinicalTrialsListSuccess,
  fetchClinicalTrialsListFailure,

  ddd,
} = clinicalTrialsListSlice.actions;

export const actions = {
  ...clinicalTrialsListSlice.actions,
};

export const useClinicalTrialsListSlice = createSliceHook(
  clinicalTrialsListSlice.name,
  actions
);
